var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('el-page-header',{attrs:{"content":"系统消息"},on:{"back":function($event){return _vm.$router.go(-1)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }